import React, { PropsWithChildren } from 'react';
import { FormPageProgress, FormPagesLayoutProgressProps } from './FormPageProgress';

import './FormPageHeader.scss';

export interface FormPagesLayoutHeaderProps {
  className?: string;
}

export function FormPageHeader({
  children,
  currentProgress,
  maximumProgress,
  className,
}: PropsWithChildren<FormPagesLayoutHeaderProps & Partial<FormPagesLayoutProgressProps>>) {
  return (
    <div className={`form-page-header ${className || ''}`}>
      {maximumProgress && <FormPageProgress currentProgress={currentProgress} maximumProgress={maximumProgress} />}
      {children}
    </div>
  );
}
